import { render } from "./Chapter.vue?vue&type=template&id=7d986704"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=7d986704&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__